var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Logo from '../../../Logo';
const LogoFacebook = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        content: (React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: 16, cy: 16, r: 13, fill: "#1877F2" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.0604 19.7578L21.6367 16H18.0312V13.5614C18.0312 12.5333 18.5349 11.5312 20.1498 11.5312H21.7891V8.33203C21.7891 8.33203 20.3013 8.07812 18.879 8.07812C15.9096 8.07812 13.9688 9.87781 13.9688 13.1359V16H10.668V19.7578H13.9688V28.8421C14.6306 28.9459 15.309 29 16 29C16.691 29 17.3694 28.9459 18.0312 28.8421V19.7578H21.0604Z", fill: "white" }))),
        alt: 'Facebook sign in',
    };
    return React.createElement(Logo, Object.assign({}, commonProps, { source: source }));
};
export default LogoFacebook;
//# sourceMappingURL=index.js.map